(() => {
  const mobileSearch = window.matchMedia('(max-width: 749px)');

  const syncSearchConditions = () => {
    document.querySelectorAll('[data-dhuni-search-toggle]').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.hidden = !mobileSearch.matches;
      panel.hidden = mobileSearch.matches && button.getAttribute('aria-expanded') !== 'true';
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dhuni-search-toggle]');
    if (!button) return;
    button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
    syncSearchConditions();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSearchConditions, { once: true });
  } else {
    syncSearchConditions();
  }
  document.addEventListener('shopify:section:load', syncSearchConditions);
  mobileSearch.addEventListener('change', syncSearchConditions);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-dhuni-advanced-search]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    const params = new URLSearchParams();
    params.set('q', input.value.trim());
    params.set('type', 'product');
    form.querySelectorAll('[data-search-filter]').forEach((select) => {
      if (select.value) params.append('dhuni_tag', select.value);
    });
    const minimumPrice = form.querySelector('[data-search-price-min]')?.value;
    const maximumPrice = form.querySelector('[data-search-price-max]')?.value;
    if (minimumPrice) params.set('dhuni_min', minimumPrice);
    if (maximumPrice) params.set('dhuni_max', maximumPrice);
    window.location.assign(`${form.action}?${params.toString()}`);
  });
})();
